import { Client } from "webstomp-client";
import { isRunning } from "@/flow/services/flow.service";
import WebsocketUrlProvider from "@/core/services/websocketUrl.provider";

export function useActivity() {
  async function checkIsRunActivityFromSocket(
    stompClient: Client,
    activityId,
    emitUpdateOutput,
    updateActivityStatus
  ): Promise<boolean> {
    return new Promise((resolve) => {
      stompClient.subscribe(
        WebsocketUrlProvider.ActivityStatus(activityId),
        (val) => {
          if (updateActivityStatus !== undefined) {
            updateActivityStatus(val.body);
          }
          if (!isRunning(val.body)) {
            if (emitUpdateOutput !== undefined) {
              emitUpdateOutput();
            }
            resolve(false);
          }
        }
      );
    });
  }

  return {
    checkIsRunActivityFromSocket,
  };
}
